<template>
    <div class="gastro-app">
        <div class="gastro-app__sidebar">

            <div class="gastro-app__sidebar__inner">
                <div class="gastro-app__logo">
                    <a href="https://ksiazece.pl/" target="_blank"></a>
                </div>
                <div class="gastro-app__sidebar__content">
                    <h3 v-html="translate('intro_header')"></h3>
                    <p v-html="translate('intro_content_1')"></p>
                    <p v-html="translate('intro_content_2')"></p>
                </div>
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
import {translate} from "@/helpers/helpers";

export default {
    name: "App",
    methods: {
        translate: translate
    }
}
</script>